import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { Stickable } from 'components/util/Stickable';
import './Header.scss';
/**
 * @component Header
 * @since 1.0.0
 */
export function Header(props) {
    const { style, sticky } = Object.assign({ style: 'normal', sticky: true }, props);
    const className = classNames('header', 'header--' + style, { 'header--sticky': sticky }, props.className);
    return (React.createElement(Stickable, null,
        React.createElement("header", { className: className }, props.children)));
}
